import { Box, Button, Paper, TextField } from '@mui/material';
import UserAvatar from '../shared/UserAvatar';
import { useMeCore } from '../../../core/modules/me';
import { useCallback, useState } from 'react';
import { useCourseCore } from '../../../core/modules/course';

interface Props {
  classId: string;
  commentId?: string;
  onSuccess: () => void;
}

const AddComment = (props: Props) => {
  const { classId, commentId, onSuccess } = props;
  const { user } = useMeCore();
  const { course, postClassComment } = useCourseCore();

  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(() => {
    setLoading(true);
    postClassComment(
      course?.id!,
      classId,
      { content, commentId, attachments: [] },
      () => {
        setContent('');
        setLoading(false);
        onSuccess();
      },
      () => {
        setLoading(false);
      }
    );
  }, [classId, commentId, content, course?.id, onSuccess, postClassComment]);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        backgroundColor: '#f8fafc',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      <UserAvatar alt={user?.name || user?.email || 'user'} src={user?.avatar} name={user?.name} email={user?.email} />
      <Box flex={1}>
        <TextField
          placeholder="Escribe tu comentario"
          fullWidth
          multiline
          minRows={3}
          value={content}
          onChange={(ev) => setContent(ev.target.value)}
        />

        {content ? (
          <Box display="flex" justifyContent="flex-end" gap={1} mt={1}>
            <Button variant="text" onClick={() => setContent('')} disabled={loading}>
              Cancelar
            </Button>
            <Button variant="contained" color="secondary" onClick={onSubmit} disabled={loading} sx={{ borderRadius: 999 }}>
              Enviar
            </Button>
          </Box>
        ) : null}
      </Box>
    </Paper>
  );
};

export default AddComment;
